import { ContentType } from '@/@types/common'

export const CONTENT_LOCALE: Record<ContentType, string> = {
	[ContentType.COMMENT]: '评论',
	[ContentType.POST]: '动态',
	[ContentType.REPOST]: '转发动态',
	[ContentType.STORY]: '日记',
	[ContentType.PERSONAL_UPDATE]: '动态',
}
